import { Coordinates } from 'models';

import { SheetModel } from './sheet-model';

export interface MapMarker {
  position: Coordinates;
  label?: string;
  icon: MarkerIcon;
  sheet?: SheetModel;
}

export enum MarkerIcon {
  HOTEL,
  SOLD_OUT,
  LANDMARK,
  AIRPORT,
  METRO,
  RESTAURANT,
  TRAIN,
  CIRCLE
}
